import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { useQueryClient } from 'react-query';
import { queryPredicate, useQueryDevices } from '@frontend/api-phone-sync';
import { usePhoneConfigShallowStore } from '@frontend/phone-config';
import { useAppScopeStore } from '@frontend/scope';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useWebsocketDeviceConnectionSubscription = () => {
  const { setPhoneConfig } = usePhoneConfigShallowStore('setPhoneConfig');
  const { selectedLocationIds } = useAppScopeStore();
  const queryClient = useQueryClient();

  const { data: devices } = useQueryDevices(selectedLocationIds, {
    select: (data) => data?.filter((device) => device.availableInContext),
  });

  useWebsocketEventSubscription(NotificationType.DEVICE_CONNECTION, (payload) => {
    const device = devices?.find((d) => d.sipProfileId === payload.params.sipProfileId);

    if (device && !!payload.params.connected) {
      setTimeout(() => {
        setPhoneConfig(device);
        queryClient.invalidateQueries({
          predicate: queryPredicate.listDevices,
        });
      }, 2000);
    } else {
      queryClient.invalidateQueries({
        predicate: queryPredicate.listDevices,
      });
      console.warn('Device not found in the current context', payload.params.sipProfileId);
    }
  });
};
